import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function TenjinHero() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    const t = setTimeout(() => {
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[640px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/22a01db047d07f0f146bce9c9970835d.jpg"
        alt="天神屋 出張買取専門店"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

      <div ref={scrollRef} className="relative z-10 flex flex-col justify-center h-full px-8 md:px-16 lg:px-24 max-w-5xl">
        <div className="mb-4">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 text-xs tracking-widest uppercase hover:text-white/80 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line text-xs"></i>
            株式会社BotaN
          </Link>
        </div>
        <p className="text-xs tracking-[0.4em] text-amber-300/80 uppercase mb-5 font-sans">
          Tenjin-ya — 出張買取専門店
        </p>
        <h1 className="text-5xl md:text-7xl font-serif font-semibold text-white leading-tight mb-6">
          大切なお品を、<br />
          <span className="text-amber-200">正しい価値で。</span>
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-xl leading-relaxed mb-10 font-sans font-light">
          福岡市・福岡県全域への出張買取専門店。<br />
          貴金属・ブランド品・カメラなど幅広く対応。<br />
          <strong className="text-white/90 font-medium">出張費・査定費は完全無料</strong>です。
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://lin.ee/OGQq9z6"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#06C755] text-white px-8 py-4 rounded-full text-sm font-medium whitespace-nowrap hover:bg-[#05b34c] transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-line-fill text-sm"></i>
            </div>
            LINEで無料査定を依頼
          </a>
          <a
            href="tel:092-577-9739"
            className="inline-flex items-center justify-center gap-2 border border-white/50 text-white px-8 py-4 rounded-full text-sm font-medium whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-xs"></i>
            </div>
            092-577-9739
          </a>
        </div>
        <div className="mt-10 flex items-center gap-6">
          <div className="flex flex-col">
            <span className="text-2xl font-serif font-semibold text-amber-200">無料</span>
            <span className="text-xs text-white/50 mt-0.5">出張・査定費用</span>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="flex flex-col">
            <span className="text-2xl font-serif font-semibold text-amber-200">即日</span>
            <span className="text-xs text-white/50 mt-0.5">現金お支払い</span>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="flex flex-col">
            <span className="text-2xl font-serif font-semibold text-amber-200">12+</span>
            <span className="text-xs text-white/50 mt-0.5">取扱ジャンル</span>
          </div>
        </div>
      </div>
    </section>
  );
}
